module.exports = __webpack_public_path__ + "static/img/yoyo.ac7be0c9.svg";